import type { RevenueDataRow, SiteRevenuePerMarketProgram } from '@/features/site/types/revenue'

export function getCurrencyFromRevenueRows(rows: RevenueDataRow[] | null | undefined): string {
  return rows?.[0]?.currency?.toUpperCase() ?? ''
}

export function getCurrencyFromRevenues(revenues: SiteRevenuePerMarketProgram | null): string {
  if (!revenues) return ''
  for (const rows of revenues.values()) {
    const currency = getCurrencyFromRevenueRows(rows)
    if (currency) return currency
  }
  return ''
}
